/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'

// components
import { Grid, TextField, FormControl, FormHelperText } from '@mui/material'
import InputLabel from '../inputLabel'

// utils
import { noop } from '../../utils/general'

// css styles
import defaultStyles from './TextInputField.module.scss'
import { minWidth } from '@mui/system'
import { useTranslation } from 'react-i18next'

function TextInputField({
  label,
  error,
  onChange,
  value,
  id,
  required = false,
  styles,
  multiLine,
  rows,
  disabled,
  placeholder,
  inputPlaceholder,
}) {
  const { t } = useTranslation()
  return (
    <Grid item>
      <FormControl sx={styles} error={error}>
        <InputLabel
          styles={{
            marginBottom: '8px',
          }}
          label={
            <>
              <span className={defaultStyles.label}>{label}</span>
              {required ? (
                <span className={defaultStyles.label}> {t('required-create-user')}</span>
              ) : (
                <span className={defaultStyles.label}> {t('optional-create-user')}</span>
              )}
            </>
          }
        />
        <TextField
          InputProps={{
            classes: {
              input: `${defaultStyles.input} ${inputPlaceholder || ''}`,
            },
          }}
          required={required}
          value={value}
          onChange={onChange}
          name={id}
          multiline={multiLine}
          rows={rows}
          disabled={disabled}
          placeholder={placeholder}
          size='small'
        />
        <FormHelperText>{error}</FormHelperText>
      </FormControl>
    </Grid>
  )
}

TextInputField.propTypes = {
  error: PropTypes.string,
  onChange: PropTypes.func,
  styles: PropTypes.object,
  multiLine: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
}

TextInputField.defaultProps = {
  error: undefined,
  onChange: noop,
  styles: { maxWidth: '400px', width: '100%', marginTop: '20px' },
  multiLine: false,
  rows: undefined,
  disabled: false,
}
export default TextInputField
